module.exports = __webpack_public_path__ + "media/images/user/favicons/android-chrome-72x72-14d6235b20c1ee09bc8a9a28c8868cfd.png";